import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from '../../../../App';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { isEndDateGreater,changeDateFormat,addMonthsToDateString,getFormattedDate,getMonthRange } from '../../../../Custom/Custom';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import titlesData from '../../../../titles.json'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../../assets/Messages.json'
import {  IndexReportWPRExcelSheet} from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import { useNavigate } from "react-router-dom";
import { API_URL } from '../../../../Constant';
import priceTitle from '../../../../price.json';

const IndexReportWPR = () => {
    const [duration, setDuration] = useState('');
    const token = useContext(MyContextProvider).token;
    const decode_token = jwtDecode(token);
    const [isDivision, setIsDivision] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const storedLanguage = localStorage.getItem('language');
    const today = new Date();

    const navigate = useNavigate();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };



const handleStartDateChange = (date) => {
    setStartDate(date);
    if (duration === 'quarterly' && date) {
        let formatData=getFormatedDate(date)
       let stringData= addMonthsToDateString(formatData,2)
        let dateData= stringData[0] + stringData.slice(1).toLocaleLowerCase()
        setEndDate(dateData)
     
    }
};

const durationOnChange=(e)=>{
    setDuration(e.target.value)
    setStartDate(null)
    setEndDate('')
}


const formatGrossValue = (value,fixedvalue) => {
    if (value === 0) return "0.00";
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return "0.00";
    return Number(value).toFixed(fixedvalue);
};
    
const getQuarterlyData=(type,item)=>{
let columnData=[];
    if(type==='monthly'){
        columnData=[formatGrossValue(item.indexdata1,2)]
    }else if(type==='quarterly'){
        columnData=[
            formatGrossValue(item.indexdata1,2), 
            formatGrossValue(item.indexdata2,2), 
            formatGrossValue(item.indexdata3,2),
            formatGrossValue(item.totalAvg,2)]
    }
    return columnData;

}


const handleGenerateExcel = () => {
        if (!startDate) {
            toast.error('Please select the date range', messages.COLOR_RED);
            return;
        }
    
       let toDate = duration === 'monthly' ? startDate : endDate;
       if (duration === 'quarterly' && !endDate) {
            toast.error('Please select the end date for the quarterly report', messages.COLOR_RED);
            return;
        }
      showLoading(true);

      let sDate=getFormattedDate(startDate)
      let eDate=duration === 'monthly'? toDate:toDate.toUpperCase()
     const payload = {
            fromDate: sDate,
            toDate: duration === 'monthly'? sDate:eDate,
            reportType: duration === 'monthly' ? '1' : '2', 
        };
    
        axios
        .post(`${API_URL}api/price/WPIIndexReport`, payload, config)
        .then((response) => {
            const wpiData = response.data.data[0].GroupCodes;
            if(wpiData.length>0){
                const mappedData = [];
         wpiData.forEach(group => {
            // Add group data
            mappedData.push({
                serial: group.serial,
                groupName: group.majorGroupName,
                percentage: group.majorGroupTotalPercentage,
                indexdata1: group.indexdata1,
                indexdata2: group.indexdata2,
                indexdata3: group.indexdata3,
                totalAvg: group.totalAvg,
            });

            group.subgroupsdata.forEach(subGroup => {
                 mappedData.push({
                    serial: subGroup.serial,
                    groupName: subGroup.subMajorGroupName,
                    percentage: subGroup.majorGroupTotalPercentage,
                    indexdata1: subGroup.indexdata1,
                    indexdata2: subGroup.indexdata2,
                    indexdata3: subGroup.indexdata3,
                    totalAvg: subGroup.totalAvg,
                 });
             
                 subGroup.majorItems.forEach(mjorGroup => {
                 mappedData.push({
                   serial: mjorGroup.serial,
                   groupName: mjorGroup.majorItemName,
                   percentage: mjorGroup.majorGroupTotalPercentage,
                   indexdata1: mjorGroup.indexdata1,
                   indexdata2: mjorGroup.indexdata2,
                   indexdata3: mjorGroup.indexdata3,
                   totalAvg: mjorGroup.totalAvg,
                });

                 mjorGroup.subItems.forEach(subItem => {
                    if(subItem.subMajorItemName !==''){
                    mappedData.push({
                      serial: subItem.serial,
                      groupName: subItem.subMajorItemName,
                      percentage: subItem.majorGroupTotalPercentage,
                      indexdata1: subItem.indexdata1,
                      indexdata2: subItem.indexdata2,
                      indexdata3: subItem.indexdata3,
                      totalAvg: subItem.totalAvg,
                   });
                }
                   subItem.items.forEach(item => {
                    mappedData.push({
                      serial: item.serial,
                      groupName: item.ItemName,
                      percentage: item.majorGroupTotalPercentage,
                      indexdata1: item.indexdata1,
                      indexdata2: item.indexdata2,
                      indexdata3: item.indexdata3,
                      totalAvg: item.totalAvg,
                   });
                   })

                 })
                })

          })

    });

         downloadExcelReport(mappedData,duration,sDate)
            }else{
                toast.error('Data is not found', messages.COLOR_RED);
                return;
            }
         })
            .catch((error) => {
                console.error('API Error:', error);
            }).finally(()=>{
                showLoading(false);
            });
    };
    



const downloadExcelReport=(wpiData,duration,sDate)=>{


let boldColumn=['PRIMARY ARTICLES','FOOD ARTICLES','FOOD GRAINS','CEREALS'
  ,'PULSES','FRUITS & VEGETABLES','FRUITS','VEGETABLES','MILK & MILK PRODUCTS','MEAT, FISH & EGGS',
    'CONDIMENTS & SPICES','NON FOOD ARTICLES','FIBERS','OIL SEEDS','OTHER NON FOOD ARTICLES','MINERALS',
    'FUEL, POWER, LIGHT & LUBRICANTS','COAL MINING','MINERALS OIL','POWER- LIGHT','LUBRICANTS','MANUFACTURED PRODUCTS',
    'FOOD PRODUCTS','DAIRY PRODUCTS','MILK PRODUCTS','OTHER FOOD ARTICLES','CANNED & PRESERVED FRUITS & VEGETABLES',
    'GRAIN MILL PRODUCTS','BAKERY PRODUCTS','SUGAR, KHANDSARI & GUR','CONFECTIONARY COCO  & CHOCOLATE','MISC. FOOD PRODUCTS',
    'EDIBLE OILS','OIL CAKES','OTHER MISC. FOOD','BEVERAGES, TOBACCO & TOBACCO PRODS.','WINE INDUSTRIES','SOFT DRINKS AND CARBONATED WATER',
    'TOBBACO MANUFACT.','TEXTILES','COTTON TEXTILES & YARN','WOOLEN YARN TEXTILES','SILK, ART SILK & SYNTHETIC',
    'JUTE, SUN & MATTE TEXTILES','WOODS & PRODUCTS','PAPER & PAPER PRODUCTS','LEATHER & LEATHER PRODUCTS','RUBBER, PLASTIC & PRODUCTS',
    'CHEMICAL AND CHEMICAL PROD.','BASIC INDUST. CHEMICALS','FERTILIZERS','PESTICIDES & INSECTICIDES','PAINTS & VARNISHES',
    'DRUGS & MEDICINES','COSMETICS, SOAPS & DETERGENTS','DYE STUFF & OTHER   CHEMICALS','NON METALLIC MINERAL PRODUCTS.','STRUCTURAL PRODUCTS',
    'GLASS & GLASS PRODUCTS','EARTHENWARE & POTTERY','CEMENT, LIME & PLASTER','MISC. NON-METALLIC MINERAL PRODUCTS','BASIC METAL ALLOYS & METAL PRODUCTS',
    'BASIC METAL ALLOYS','IRON,STEEL AND FERROUS ALLOYS','NON-FERROUS METALS & ALLOYS','METAL PRODUCTS','MACHINERY & MACHINERY TOOLS','MACHINERY & TOOLS (Except electrical)',
    'ELECTRICAL MACHINERY, APPARATUS & APPLIANCES','TRANSPORT EQUIPMENTS ','MOTOR VEHICLES','MOTOR CYCLES, SCOOTERS, BICYCLES & ARTS.',''
]
    let sheetLastCoumn=duration === 'monthly' ? [sDate] : [...getMonthRange(sDate,2),'AVG'];
    const excelObjectData = {
        fileName:'WPI_INDEX' ,
         fileType: 'xls',
        sheetName: duration === 'monthly' ? 'wpiindexReportmonthly' : 'indexReport_Table',
        firstRowMergeCells: duration === 'monthly' ? 'A1:D1' : 'A1:G1',
        firstRowExportDate: changeDateFormat(new Date()),
       secondRowMergeCells: duration === 'monthly' ? 'A2:D2' : 'A2:G2',
        secondRowText: `सारिणी-2  उत्तर प्रदेश के थोक भाव सूचकांक (आधार वर्ष 2011-12=100)`,
        thirdRowMergeCells: duration === 'monthly' ? 'A3:D3' : 'A3:G3',
        thirdRowText: `Table-2 Whole sale price index( Base Year 2011-12=100)`,
        headerEnglishColumns: [
            'Sr.no.', 'Groups & Items', 'Percentage Weight', ...sheetLastCoumn
        ],
        boldColumn:boldColumn
       
    };

        const transformedData = wpiData.map(item => [
            item.serial,
            item.groupName,
            formatGrossValue(item.percentage,4),
            ...getQuarterlyData(duration,item)
          
         ]);

        excelObjectData.excelRowData = transformedData;


        IndexReportWPRExcelSheet(excelObjectData);


}

    const getFormatedDate = (date) => {
        if (!date) return '';
        const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
    };

    return (
        <>
            <GlobalLoading />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.INDEX_REPORT_WPR : priceTitle.en.INDEX_REPORT_WPR }} />
                             </h4>
                            <div className="row align-items-center">
                                {isDivision && (
                                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                        <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION}</label>
                                        <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                                    </div>
                                )}

                                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                                    <label>Duration</label>
                                    <select
                                        className="form-select"
                                        value={duration}
                                        onChange={durationOnChange}
                                    >
                                        <option value="" disabled>[---Select--]</option>
                                        <option value="monthly">Monthly</option>
                                        <option value="quarterly">Quarterly</option>
                                    </select>
                                </div>

                       
                                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                        <label className="fw-bold h6">From Date</label>
                                        <DatePicker
                                            className="form-control calendar_icon"
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            dateFormat="MMM yyyy"
                                            showMonthYearPicker
                                            placeholderText="Select month"
                                            maxDate={today}
                                        />
                                    </div>
                            

                                {duration === 'quarterly' && (
                                    <>
                                        {/* <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                            <label className="fw-bold h6">From Date</label>
                                            <DatePicker
                                                className="form-control calendar_icon"
                                                selected={startDate}
                                                onChange={handleStartDateChange}
                                                dateFormat="MMM yyyy"
                                                showMonthYearPicker
                                                placeholderText="Select month"
                                                maxDate={today}
                                            />
                                        </div> */}

                                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                            <label className="fw-bold h6">To Date</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={endDate}
                                                readOnly
                                            />
                                        </div>
                                    </>
                                )}

                                <div className="col-xl-2 col-lg-4 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default IndexReportWPR